export enum EPostStatus {
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  DRAFT = 'DRAFT'
}
